<script lang="ts" setup>
import CtaBanner from "@/components/CtaBanner.vue";
import CtaButton from "@/components/CtaButton.vue";

const { t } = useI18n();
</script>

<template>
  <CtaBanner class="cta-banner-get-ready-for-school" :direction-row="true">
    <div class="cta-banner-get-ready-for-school__image">
      <img
        src="@/images/cta_banner/ready-for-school.svg"
        alt="ready-for-school"
        loading="lazy"
      />
    </div>
    <div class="cta-banner-get-ready-for-school__text">
      <h2 class="cta-banner-get-ready-for-school__title">
        {{ t("startPage.ctaBanner.readyForSchool.title") }}
      </h2>

      <p
        v-safe-html="t('startPage.ctaBanner.readyForSchool.text')"
        class="cta-banner-get-ready-for-school__content"
      />

      <CtaButton href="https://fobizz.com/angebote-fuer-schulen-und-gruppen/" />
    </div>
  </CtaBanner>
</template>

<style scoped lang="scss">
.cta-banner-get-ready-for-school {
  &__image {
    padding-top: 2rem;
    margin-bottom: -2.5rem;

    @include media-breakpoint-down(md) {
      margin-bottom: 0;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: $spacer-3;
  }

  &__title {
    font-size: $h1-font-size;
    font-weight: $font-weight-semibold;
    line-height: 2.5rem;
  }

  &__content {
    font-size: $h5-font-size;
    line-height: 1.875rem;
  }

  &__title,
  &__content {
    color: $color-primary;
  }

  @include media-breakpoint-down(lg) {
    &__title {
      font-size: $h2-font-size;
      margin-bottom: 0;
    }
  }

  @include media-breakpoint-down(md) {
    &__title {
      font-size: $h3-font-size;
      line-height: 2rem;
    }
  }
}
</style>
